import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0df20e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cls_content" }
const _hoisted_2 = { class: "cls_left" }
const _hoisted_3 = { class: "cls_left_ul" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "cls_left_name" }
const _hoisted_6 = { class: "cls_right" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "cls_right_item_all" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ALL ")
const _hoisted_10 = { class: "cls_right_icon_list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "cls_right_icon_name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_tabbar = _resolveComponent("tabbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cls_datas, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              onClick: ($event: any) => ($setup.left_click_fn(item, index)),
              key: 'cls_left_item_' + index,
              class: _normalizeClass($setup.sld_item_id === item.gc_id ? 'cls_left_li sld_left_li' : 'cls_left_li')
            }, [
              _createVNode(_component_van_icon, {
                name: _ctx.webpFilters(item.big_pic),
                color: "#1989fa",
                size: "25px"
              }, null, 8, ["name"]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.gc_name), 1)
            ], 10, _hoisted_4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.child_list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "cls_right_item",
            key: 'cls_right_item_' + index
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => ($setup.actv_search_fn(item)),
              class: "cls_right_item_title"
            }, [
              _createTextVNode(_toDisplayString(item.gc_name) + " ", 1),
              _createElementVNode("b", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_van_icon, { name: "arrow" })
              ])
            ], 8, _hoisted_7),
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child, (icon_item, icon_index) => {
                return (_openBlock(), _createElementBlock("li", {
                  onClick: ($event: any) => ($setup.actv_search_fn(icon_item)),
                  class: "cls_right_icon_item",
                  key: 'cls_right_icon_' + icon_index
                }, [
                  _createVNode(_component_van_icon, {
                    name: _ctx.webpFilters(icon_item.big_pic),
                    color: "#1989fa",
                    size: "50px"
                  }, null, 8, ["name"]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(icon_item.gc_name), 1)
                ], 8, _hoisted_11))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_tabbar, { active: $setup.tabbar_index }, null, 8, ["active"])
  ], 64))
}